import { notification } from 'antd';
import { useEffect, useState } from 'react';

import apiDatalake from '../../../../services/apiDatalake';

const useMedidaProdutoData = ({ filters, clientes }) => {
  const [medidaProdutoData, setMedidaProdutoData] = useState([]);
  const [loadingMedidaProdutoData, setLoadingMedidaProdutoData] = useState(
    false
  );

  useEffect(() => {
    const getMedidaProdutoData = async () => {
      if (!clientes) {
        return;
      }

      setLoadingMedidaProdutoData(true);
      try {
        if (filters?.periodo !== null) {
          const { data } = await apiDatalake.post(
            'buscar-medida-dinamica-produto-shipper',
            {
              cpf_cnpj_cliente: clientes,
              ...(filters.periodo[0] && {
                data_inicial: filters.periodo[0].toDate(),
              }),
              ...(filters.periodo[1] && {
                data_final: filters.periodo[1].toDate(),
              }),
              ...(filters.produto &&
                filters.produto?.value !== 'Todos' && {
                  produto: filters.produto.value,
                }),
              ...(filters.cidade &&
                filters.cidade?.value !== 'Todas' && {
                  cidade: filters.cidade.value,
                }),
              ...(filters.estado &&
                filters.estado?.value !== 'Todos' && {
                  estado: filters.estado.value,
                }),
            }
          );

          if (data) {
            setMedidaProdutoData(data.lista_produtos);
          }
        }
      } catch {
        notification.error({
          message: 'Não foi possível obter os dados de produto',
          description: 'Tente novamente ou entre em contato com o suporte',
        });
      }
      setLoadingMedidaProdutoData(false);
    };
    getMedidaProdutoData();
  }, [
    filters.periodo,
    filters.produto,
    filters.cidade,
    filters.estado,
    clientes,
  ]);

  return {
    medidaProdutoData,
    loadingMedidaProdutoData,
  };
};

export default useMedidaProdutoData;
